import { render, staticRenderFns } from "./PricerClients.vue?vue&type=template&id=438ab3f4"
import script from "./PricerClients.vue?vue&type=script&lang=js"
export * from "./PricerClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports